import _ from 'lodash';
import GatewayService from '../GatewayService.js';
var workSummary = new GatewayService('work-summary-svc');

var fetchWorkSummaryStatus = function fetchWorkSummaryStatus(userKey, cardstackKey) {
  return workSummaryStatusExists(userKey, cardstackKey).then(function (exists) {
    if (exists) {
      return workSummary.get("storage/item/".concat(userKey, "/").concat(cardstackKey, "/cardstack-status"));
    } else {
      return;
    }
  });
};

var workSummaryStatusExists = function workSummaryStatusExists(userKey, cardstackKey) {
  return workSummary.get("storage/list/".concat(userKey, "/").concat(cardstackKey), {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (data) {
    return !_.isEmpty(data.filter(function (item) {
      return item.indexOf('cardstack-status') > -1;
    }));
  });
};
/**
 * @param {Array<Array<String>>} userKeyTuplesList user/cardstackkey tuples
 * @return {Promise<Array<Object>>} A promise resolving to an array of work summary
 * storage data grouped by cardstacks and userId.
 */


var fetchBulkWorkSummaryStatus = function fetchBulkWorkSummaryStatus(userKeyTuplesList) {
  return workSummary.post('storage/batchAll', userKeyTuplesList, {
    params: {
      includeData: true
    }
  }).then(function (resp) {
    return _.map(resp, function (workSummaryData) {
      return {
        userKey: workSummaryData.groupKey,
        cardstackKey: _.first(workSummaryData.itemKey.split('/')),
        status: JSON.parse(workSummaryData.content),
        data: workSummaryData
      };
    });
  });
};

export default {
  fetchWorkSummaryStatus: fetchWorkSummaryStatus,
  fetchBulkWorkSummaryStatus: fetchBulkWorkSummaryStatus
};